import { Slider } from "../../components/slider/slider";
import { MediaImage } from "../../components/media/mediaImage";
import { CgBreakpoints } from "../../components/common/cgBreakpoints";


export class StructureGallery {
    defaultOptions = {
        wrapperClass: "structure__content",
        slideClass: "card-news",
        direction: 'horizontal',
        slidesPerView: 3,
        slidesPerColumn: 3,
        slidesPerColumnFill: 'row',
        spaceBetween: 1,
        breakpoints: {
            980: {
                slidesPerView: 2,
                slidesPerColumn: 3,
                slidesPerGroup: 2,
            },
        },
        navigation: {
            prevEl: ".pagination-control__navigation--prev",
            nextEl: ".pagination-control__navigation--next",
        },
    };

    errorTPL = "<p>Se ha producido un error inesperado</p>";
    buttonTPL = [
        '<p class="pagination-browser">',
        '<button type="button" class="pagination-browser__button">Ver Más</button>',
        '</p>',
    ].join("");

    swipers = [];

    slidesPerView = 3;

    // staff
    structure;

    firtsTimeDropDown = true;

    constructor() {
        this.init();
    }

    init() {
        this.structure = $('.structure--gallery');
        if (!this.structure.length) {
            return;
        }

        if (!this.isMobile()) {
            const swiper = new Slider(this.structure, this.defaultOptions);
            this.swipers.push(swiper);
        } else {
            this.addButton();
        }

        this.bindEvents();
    }

    bindEvents() {
        this.structure.on("click", ".pagination-browser__button", (e) => {
            e.preventDefault();
            this.showCards($(e.currentTarget));
        });

        this.structure
            .on("click", ".section-header__tabs .lnk", (e) => {
                e.preventDefault();

                const navDropdownSubmenu = $('.navigation-dropdown__submenu');

                $("a.lnk > span").removeClass("navigation-dropdown__color");
                if (navDropdownSubmenu.hasClass("navigation-dropdown__submenu--active")) {
                    navDropdownSubmenu.removeClass('navigation-dropdown__submenu--active');
                }
                $(e.currentTarget)
                    .closest("ul.section-header__tabs")
                    .find("a.lnk > span")
                    .first()
                    .addClass("navigation-dropdown__color");

                this.loadCards($(e.currentTarget));
                this.showButton();
            })
            .on(
                "click",
                ".navigation-dropdown--thesaurus-filter .navigation-dropdown__submenu .lnk",
                (e) => {
                    e.preventDefault();
                    this.loadCards($(e.currentTarget));
                }
            )
            .on(
                "click",
                ".navigation-dropdown--category-filter .navigation-dropdown__submenu .lnk",
                (e) => {
                    $(e.currentTarget)
                        .parents(".navigation-dropdown__submenu")
                        .toggleClass("navigation-dropdown__submenu--active");

                    $("a.lnk > span").removeClass("navigation-dropdown__color");
                    $(e.currentTarget)
                        .closest("ul.navigation-dropdown--category-filter")
                        .find("a.lnk > span")
                        .first()
                        .addClass("navigation-dropdown__color");

                    e.preventDefault();
                    this.loadCards($(e.currentTarget));
                    this.showButton();
                }
            )
            .on(
                "click",
                ".navigation-dropdown--alphabetical-filter .navigation-dropdown__submenu .lnk",
                (e) => {
                    $(e.currentTarget)
                        .parents(".navigation-dropdown__submenu")
                        .toggleClass("navigation-dropdown__submenu--active");

                    $("a.lnk > span").removeClass("navigation-dropdown__color");
                    $(e.currentTarget)
                        .closest("ul.navigation-dropdown--alphabetical-filter")
                        .find("a.lnk > span")
                        .first()
                        .addClass("navigation-dropdown__color");

                    e.preventDefault();
                    this.loadCards($(e.currentTarget));
                    this.showButton();
                }
            )
            .on(
                "click",
                ".navigation-dropdown--category-filter .lnk",
                () => {
                    const alfabeticalSubmenu = $('.navigation-dropdown--alphabetical-filter .navigation-dropdown__submenu');
                    if (alfabeticalSubmenu.hasClass("navigation-dropdown__submenu--active")) {
                        alfabeticalSubmenu.removeClass('navigation-dropdown__submenu--active');
                    }
                }
            )
            .on(
                "click",
                ".navigation-dropdown--alphabetical-filter .lnk",
                () => {
                    const categorySubmenu = $('.navigation-dropdown--category-filter .navigation-dropdown__submenu');
                    if (categorySubmenu.hasClass("navigation-dropdown__submenu--active")) {
                        categorySubmenu.removeClass('navigation-dropdown__submenu--active');
                    }
                }
            );
    }

    loadCards(button) {
        const container = button
            .closest(".structure--gallery")
            .find(".structure__content");

        container
            .css("height", container.outerHeight())
            .addClass("structure__content--loading");

        const params = {
            fragment: 1,
        };

        $.ajax({
            url: button.prop("href"),
            type: "GET",
            data: params,
        })
            .done((res) => {
                if (res.errors.length) {
                    this.showErrorMessage(container, res.errors);
                } else {
                    this.setActiveTag(button);

                    if (!this.isMobile()) {
                        container
                            .html(res.data.html)
                            .find(".card-news")
                            .wrap('<div class="slider__slide" />');

                        if (this.swipers.length) {
                            this.swipers[0].update();
                        }
                    } else {
                        container.html(res.data.html).find(".card-news");
                    }

                    this.loadImages();
                }
            })
            .fail((err) => {
                this.showErrorMessage(container, err);
            })
            .always(() => {
                if (!container.is(".structure__content--error")) {
                    container
                        .removeClass("structure__content--loading")
                        .css("height", "auto");

                    const categoryFilter = $('.navigation-dropdown__submenu');
                    if (categoryFilter.length > 0) {
                        categoryFilter.each((index, el) => {
                            const sectionName = button.closest('.structure--gallery').find('.section-header__name');
                            const originalMenuHeight = $(el).outerHeight();
                            let newMenuHeight;

                            if (this.firtsTimeDropDown === true) {
                                $(el).data("originalHeight", originalMenuHeight)
                            }

                            if ($(el).outerHeight() > container.outerHeight()
                                || $(el).data('originalHeight') > container.outerHeight()) {
                                newMenuHeight = container.outerHeight() + sectionName.outerHeight();
                            } else {
                                newMenuHeight = $(el).data('originalHeight');
                            }

                            $(el)
                                .css('overflow-y', 'scroll')
                                .css('height', newMenuHeight);
                        });

                        this.firtsTimeDropDown = false;
                    }
                }
            });
    }

    showCards(button) {
        const slides = button
            .closest(".structure--gallery")
            .find("." + this.defaultOptions.slideClass)
            .filter(":hidden");

        slides.slice(0, this.slidesPerView).fadeIn(() => {
            this.loadImages();
        });

        if (!slides.length) {
            this.removeButton($button);
        }
    }

    showButton() {
        const hiddenElements = $(".structure__content").find("." + this.defaultOptions.slideClass).filter(":hidden");
        const browserButton = $('.structure--gallery .pagination-browser .pagination-browser__button');

        if (this.isMobile()
            && hiddenElements.length
            && !browserButton.length) {

            this.addButton();
        }
    }

    // auxiliary
    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }

    addButton() {
        this.structure.append(this.buttonTPL);
    }

    removeButton(button) {
        button.remove();
    }

    setActiveTag(button) {
        $("span.section-header__name")
            .css("display", "flex")
            .text(button.text().toUpperCase());
        $("a.lnk").removeClass("lnk-color--active");

        button
            .closest(".structure--gallery")
            .find("a.lnk--active")
            .removeClass("lnk--active")
            .end()
            .end()
            .closest(".navigation-dropdown")
            .find('a[href^="#navigation-dropdown__submenu"] span')
            .end()
            .end()
            .addClass("lnk-color--active");
    }

    showErrorMessage(container, err) {
        console.debug("err", err);
        container.addClass("structure__content--error").html(this.errorTPL);
    }

    loadImages() {
        new MediaImage();
    }
}
